import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorDelete } from "../../Utils/saga"
import Creators, { PricingTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getPricingFilterOptionsActions: {
    request: Creators.getPricingFilterOptionsRequest,
    success: Creators.getPricingFilterOptionsSuccess,
    errors: Creators.getPricingFilterOptionsFailure
  },
  getPricingActions: {
    request: Creators.getPricingRequest,
    success: Creators.getPricingSuccess,
    errors: Creators.pricingFailure
  },
  getPricingExportActions: {
    request: Creators.getPricingExportRequest,
    success: Creators.getPricingExportSuccess,
    errors: Creators.getPricingExportFailure
    //downloadFile: true,
  },
  createPricingActions: {
    request: Creators.createPricingRequest,
    success: Creators.createPricingSuccess,
    errors: Creators.pricingFailure
  },
  updatePricingActions: {
    request: Creators.updatePricingRequest,
    success: Creators.updatePricingSuccess,
    errors: Creators.pricingFailure
  },
  deletePricingActions: {
    request: Creators.deletePricingRequest,
    success: Creators.deletePricingSuccess,
    errors: Creators.pricingFailure
  }
}

const eventsOptions = {
  [constants.GET_PRICING_FILTER_OPTIONS_REQUEST]: {
    api: services.getPricingFilterOptions,
    actions: actions.getPricingFilterOptionsActions
  },
  [constants.GET_PRICING_REQUEST]: {
    api: services.getPricing,
    actions: actions.getPricingActions
  },
  [constants.GET_PRICING_EXPORT_REQUEST]: {
    api: services.getPricingExport,
    actions: actions.getPricingExportActions
  },
  [constants.CREATE_PRICING_REQUEST]: {
    api: services.createPricing,
    actions: actions.createPricingActions
  },
  [constants.UPDATE_PRICING_REQUEST]: {
    api: services.updatePricing,
    actions: actions.updatePricingActions
  },
  [constants.DELETE_PRICING_REQUEST]: {
    api: services.deletePricing,
    actions: actions.deletePricingActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_PRICING_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_PRICING_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_PRICING_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_PRICING_REQUEST])
  )
  yield takeLatest(constants.GET_PRICING_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_PRICING_EXPORT_REQUEST])
  )
  yield takeLatest(constants.CREATE_PRICING_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.CREATE_PRICING_REQUEST])
  )
  yield takeLatest(constants.UPDATE_PRICING_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_PRICING_REQUEST])
  )
  yield takeLatest(constants.DELETE_PRICING_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_PRICING_REQUEST])
  )
}
